import { render } from "./Disconnected.vue?vue&type=template&id=affd36d6&scoped=true"
import script from "./Disconnected.vue?vue&type=script&lang=js"
export * from "./Disconnected.vue?vue&type=script&lang=js"

import "./Disconnected.vue?vue&type=style&index=0&id=affd36d6&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-affd36d6"]])

export default __exports__